
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Lead } from '@/types';

@Component
export default class LeadEraseDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  loading = false
  eraseChildren = true

  @Watch('value')
  onValueChange(val: boolean) {
    console.log('LeadEraseDialog: onValueChange()'); // eslint-disable-line no-console

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get hasChildren(): boolean {
    return this.lead?.Tasks?.some((task) => task.relationship === 'father') ?? false;
  }

  get childrenCount(): number {
    const childIds = new Set();
    if (this.lead?.Tasks) {
      this.lead.Tasks.forEach((task) => {
        if (task.relationship === 'father' && task.childLeadId) {
          childIds.add(task.childLeadId);
        }
      });
    }
    return childIds.size;
  }

  async onCancel() {
    console.log('LeadEraseDialog: onCancel()'); // eslint-disable-line no-console

    this.dialog = false;
  }

  async onErase() {
    console.log('LeadEraseDialog: onErase()'); // eslint-disable-line no-console

    this.loading = true;

    try {
      await this.$store.dispatch('eraseLead', this.eraseChildren);

      // Torna all'elenco
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$router.replace({ name: 'Elenco' }, () => {});
    } catch (err) {
      // Se l'eliminazione fallisce lato server dobbiamo comunque spegnere il
      // loading (altrimenti il dialog resta in caricamento infinito) e chiudere.
      console.error('LeadEraseDialog: onErase error', err); // eslint-disable-line no-console
      this.loading = false;
      this.dialog = false;
    }
  }
}
